import { useQuery } from '@tanstack/react-query';
import { CommonConstant } from 'constants/code.constant';
import DashboardRepository from 'repositories/DashboardRepository';
import CommonUtil from 'utils/common.util';

const useDashboard = () => {
  const useGetDashboard = () => {
    const getDashboard = () => {
      return DashboardRepository.getDashboard()
        .then((res) => {
          if (res.result === CommonConstant.OK) {
            return res.data;
          } else {
            console.error(res);
          }
        })
        .catch(CommonUtil.repoErrFunc);
    };

    const dashboardQuery = useQuery({
      queryKey: ['dashboard'],
      queryFn: getDashboard,
    });

    return {
      dashboardInfo: dashboardQuery.data || null,
      refetch: dashboardQuery.refetch,
    };
  };

  return { useGetDashboard };
};

export default useDashboard;
